// extracted by mini-css-extract-plugin
module.exports = {"e2e-solutions":"styles_e2e-solutions__2Z3vv","cross-border":"styles_cross-border__py-6V","list-item":"styles_list-item__2oh5Q","pb-44px":"styles_pb-44px__lyI3x"};